import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs';
import VirtualWallList from './virtualWalletList/VirtualWallList';
import VirtualWalletFills from './virtualWallFill/VirtualWalletFill';
import ReversalWalletCards from './ReversalWalletCards';
import AdminVirtualSupplyCards from './AdminVirtualSupplyCards';
import ReversalAssignModal from './ReversalAssignModal';
import { getUpdateProfile, virtualWalletsFilter, getAdminVirtualWalletBalance } from '../../api/login/Login';
import { FaCoins, FaExchangeAlt } from 'react-icons/fa';

function VirtualWallet() {
    const breadCrumbsTitle = {
        id: "1",
        title_1: "Payments",
        title_2: "Virtual Supply & Distribution",
    };
    
    const [activeTab, setActiveTab] = useState('virtual_supply'); // 'virtual_supply' | 'reversal_pools'
    const [loading, setLoading] = useState(false);
    const [count, setCount] = useState(10);
    const [page, setPage] = useState(0);
    const [data, setData] = useState(null);
    const [totalCount, setTotalCount] = useState();

    // Virtual supply balances state
    const [virtualBalances, setVirtualBalances] = useState({
        main_wallet: 0,
        aeps_wallet: 0,
        cashback_wallet: 0,
    });
    const [virtualLoading, setVirtualLoading] = useState(false);

    // Reversal wallet pools state
    const [walletBalances, setWalletBalances] = useState(null);
    const [balancesLoading, setBalancesLoading] = useState(false);

    const [filterValues, setFilterValues] = useState({});

    // Virtual supply assign modal state
    const [virtualAssignModalOpen, setVirtualAssignModalOpen] = useState(false);
    const [selectedVirtualCard, setSelectedVirtualCard] = useState(null);

    const handleOpenVirtualAssign = (card) => {
        setSelectedVirtualCard(card);
        setVirtualAssignModalOpen(true);
    };

    const fetchVirtualBalances = async () => {
        setVirtualLoading(true);
        try {
            const res = await getAdminVirtualWalletBalance();
            const resData = res?.data?.data || res?.data || res;
            if (resData) {
                setVirtualBalances({
                    main_wallet: resData.main_wallet ?? 0,
                    aeps_wallet: resData.aeps_wallet ?? 0,
                    cashback_wallet: resData.cashback_wallet ?? 0,
                });
            }
        } catch (error) {
            console.error("Failed to fetch admin virtual balances:", error);
        } finally {
            setVirtualLoading(false);
        }
    };

    const fetchWalletBalances = async () => {
        setBalancesLoading(true);
        try {
            const res = await getUpdateProfile();
            setWalletBalances(res?.data?.staff);
        } catch (error) {
            console.error("Failed to fetch reversal wallet balances:", error);
        } finally {
            setBalancesLoading(false);
        }
    };

    const submitForm = async (values, targetPage = 0) => {
        setLoading(true);
        const activeFilters = typeof values === 'object' && values !== null ? values : filterValues;
        if (typeof values === 'object' && values !== null) {
            setFilterValues(values);
        }
        const activePage = typeof targetPage === 'number' ? targetPage : page;
        try {
            const res = await virtualWalletsFilter(activePage, count, activeFilters);
            const walletList = res?.data?.wallet || res?.wallet || [];
            const total = res?.data?.total ?? res?.total ?? 0;
            setData(walletList);
            setTotalCount(total);
        } catch (error) {
            console.error("Failed to fetch virtual wallet list:", error);
        } finally {
            setLoading(false);
        }
    };

    const onChangeVal = (e) => {
        const newPage = e - 1;
        setPage(newPage);
        submitForm(filterValues, newPage);
    };

    useEffect(() => {
        fetchVirtualBalances();
        fetchWalletBalances();
        submitForm({});
    }, []);

    return (
        <>
            <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />

            {/* Top Pool Category Selector Tabs */}
            <div className="container-fluid px-4 pt-2">
                <div className="d-flex gap-2 border-bottom pb-2 mb-2">
                    <button
                        type="button"
                        className={`btn btn-sm rounded-pill px-4 fw-bold ${
                            activeTab === 'virtual_supply'
                                ? 'btn-primary shadow-sm'
                                : 'btn-outline-secondary'
                        }`}
                        onClick={() => setActiveTab('virtual_supply')}
                    >
                        <FaCoins className="me-1" /> Admin Virtual Supply Pools (Current Balances)
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm rounded-pill px-4 fw-bold ${
                            activeTab === 'reversal_pools'
                                ? 'btn-primary shadow-sm'
                                : 'btn-outline-secondary'
                        }`}
                        onClick={() => setActiveTab('reversal_pools')}
                    >
                        <FaExchangeAlt className="me-1" /> Reversal Holding Pools (Option B)
                    </button>
                </div>
            </div>

            {/* Display Active Pool Cards */}
            {activeTab === 'virtual_supply' ? (
                <AdminVirtualSupplyCards 
                    virtualBalances={virtualBalances} 
                    loading={virtualLoading} 
                    onRefresh={fetchVirtualBalances} 
                    onOpenAssign={handleOpenVirtualAssign}
                />
            ) : (
                <ReversalWalletCards 
                    walletData={walletBalances} 
                    loading={balancesLoading} 
                    onRefresh={fetchWalletBalances} 
                />
            )}

            {/* Virtual Supply Assign Modal */}
            {virtualAssignModalOpen && selectedVirtualCard && (
                <ReversalAssignModal
                    open={virtualAssignModalOpen}
                    onClose={() => setVirtualAssignModalOpen(false)}
                    poolType={
                        selectedVirtualCard.id === 'aeps_wallet'
                            ? 'Aeps Wallet'
                            : selectedVirtualCard.id === 'cashback_wallet'
                            ? 'Cashback Wallet'
                            : 'Main Wallet'
                    }
                    poolTitle={selectedVirtualCard.title}
                    availableBalance={selectedVirtualCard.balance}
                    gradient={selectedVirtualCard.cardGradient}
                    badgeBg={selectedVirtualCard.badgeBg}
                    badgeColor={selectedVirtualCard.badgeColor}
                    sourceType="virtual_supply"
                    onSuccess={() => {
                        fetchVirtualBalances();
                        submitForm(filterValues, page);
                    }}
                />
            )}

            <VirtualWalletFills submitForm={submitForm} />
            <VirtualWallList data={data} totalCount={totalCount} onChangeVal={onChangeVal} loading={loading} />
        </>
    );
}

export default VirtualWallet;